import { UsageStatsType } from "../../../index";

interface UsageStatsProps {
	id: string;
	name: string;
	description: string;
	type: UsageStatsType;
	max?: number;
}

class UsageStats {
	constructor(public _: UsageStatsProps) {}

	static fromJson(json: any) {
		return new UsageStats({
			id: json.id,
			name: json.name,
			description: json.description,
			type: json.type,
			max: json.max,
		});
	}

	toJson() {
		return {
			id: this._.id,
			name: this._.name,
			description: this._.description,
			type: this._.type,
			max: this._.max,
		};
	}
}

export { UsageStats };
